import produce from 'immer';
import {
  DEFAULT_EVENT_ON,
  SENSOR_F01,
  SETPOINT_I_S01,
} from '../../../../controlUnit/api/util/constants';
import { CommanderMonitoringFilterLogicalObject } from './filter.model';

const DEFAULT_CHANNELS = [SENSOR_F01, SETPOINT_I_S01, DEFAULT_EVENT_ON];

export function checkDefaultChannels(
  commanderMonitoringFilterLogicalObject: CommanderMonitoringFilterLogicalObject,
  showAllChannels = false,
  defaultChannels = DEFAULT_CHANNELS,
  defaultControlUnits: string[] = [],
  selectOneIfNone = true
) {
  return produce(
    commanderMonitoringFilterLogicalObject,
    (commanderMonitoringFilterLogicalObjectDraft) => {
      for (const deviceId in commanderMonitoringFilterLogicalObjectDraft) {
        if (
          Object.prototype.hasOwnProperty.call(
            commanderMonitoringFilterLogicalObjectDraft,
            deviceId
          )
        ) {
          const deviceObjectFilter =
            commanderMonitoringFilterLogicalObjectDraft[deviceId];
          for (const controlUnitId in deviceObjectFilter) {
            if (
              Object.prototype.hasOwnProperty.call(
                deviceObjectFilter,
                controlUnitId
              )
            ) {
              const controlUnitObjectFilter = deviceObjectFilter[controlUnitId];
              for (const eventId in controlUnitObjectFilter) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    controlUnitObjectFilter,
                    eventId
                  )
                ) {
                  if (defaultChannels.includes(eventId) || showAllChannels) {
                    if (
                      defaultControlUnits.length === 0 ||
                      defaultControlUnits.includes(controlUnitId)
                    ) {
                      controlUnitObjectFilter[eventId] = true;
                    }
                  }
                }
              }
              // Check if at least one default channel is selected, if not select the first one
              if (controlUnitObjectFilter && selectOneIfNone) {
                const hasDefaultChannel = Object.keys(
                  controlUnitObjectFilter
                ).some((eventId) => defaultChannels.includes(eventId));
                if (!hasDefaultChannel) {
                  const firstKey = Object.keys(controlUnitObjectFilter)[0];
                  controlUnitObjectFilter[firstKey] = true;
                }
              }
            }
          }
        }
      }
    }
  );
}
